module.exports = {
    SI_UNIT_BRITISH: "uk",
    SI_UNIT_US: "us",
    SI_UNIT_DEFAULT: "uk",
    FADE_IN_TRANSITION_TIMEOUT: 700,
    DEFAULT_BACKGROUND_URL: "partly-cloudy-night",
    DEFAULT_SET_BOTTOM_BAR: true,
    DEFAULT_AREA_STR: "Unknown",
    DARK_THEME_CLASS: "dark-bg-theme",
    LIGHT_THEME_CLASS: "light-bg-theme",
    DEFAULT_THEME: "light-bg-theme",
    DEFAULT_TOOL_TIP_TIMEOUT_MS: 5000,
    FCM_TOKEN: 'fcmToken',
    DEVICE_ID: 'deviceID',
    REFRESH_SUCCESS_MESSAGE: "Updated Weather!",
    REFRESH_ERROR_MESSAGE: "Refresh Error. Please Try Again :(",
    IS_PREMIUM_USER: "is_premium_user",
    REMOVE_ADS_BAR: "remove_ads_bar",
    GENERAL_NEWS_REFRESH: "general_news_refresh",
    LAST_UPDATED_MSG: {
        JUST_NOW: "Updated Just Now",
        MINS_AGO: "Updated Few Minutes Ago",
        HOUR_AGO: "Updated More Than An Hour Ago",
    },
    LAST_UPDATED_MSG_FREQ_TIMEOUT_MS: 5000,

    MIN_REFRESH_TIME_DELTA_MS: 2000,

    ARGS: {
        LATITUDE: "lat",
        LONGITUDE: "lon",
        COUNTRY: "country",
        ZIP_CODE: "zip_code",
        CITY: "city",
        AREA: "area",
        SI: "si",
        SRC: "src",
        SHOW_SEARCH_BAR: "show_search_bar",
        SHOW_PREMIUM_FEATURE: "premium"
    },

    LOCATION_REFRESH_THROTTLER_SECS: 1,

    WEATHER_SRC: {
        MANUAL: "manual",
        NATIVE_GEO: "native-geo",
    },
    LOCATION_STORE: {
        LOCATION_STORE_KEY: "stored_locations",
        CURRENT_LOCATION_INDEX: "current_location_index",
        IS_CURR_LOC_FROM_GEO: "is_current_loc_from_geo",
        GEO_LOCATION: "geo_location",
    },

    FCM_STORE: {
        DEVICE_TOKEN: 'device-token',
        SHOW_PREMIUM_FEATURE: 'premium'
    },

    LOCATION_DETECT_STORAGE_KEY: "is_location_detect_dismissed",
    LOCATION_DETECT_SHOWN_VAL: "shown",

    LOCATION_PERMISSION_STATUS: {
        INVALID: 0,
        DENIED: 1,
        GRANTED: 2,
    },

    ENV: {
        INTERNAL: "internal"
    },

    ANALYTICS: {
        EVENTS: {
            CATEGORY: {
                DATA: "weather-fetch",
                LOC_TYPE: "location-type",
                CLICK: "click",
                COMP_LOAD: "component-load",
                LOCATION: "location",
                SIDEBAR: "sidebar",
                WEATHER_PAGE: '-1screen',
                AD_ABOVE_FOLD: '-1screenabovefold',
                AD_SECOND_FOLD: '-1screensecondfold'
            },
            ACTION: {
                FETCH_START: "fetch-start",
                FETCH_SUCCESS: "fetch-success",
                FETCH_FAIL: "fetch-fail",
                LOC_IP: "lm_ip",
                LOC_NATIVE: "lm_app",
                TOGGLE_UNIT: "toggle-unit",
                TOGGLE_TIME: "toggle-time-interval",
                COMP_LOADING: "loading",
                COMP_WEATHER: "weather",
                COMP_LOCATION_FINDER: "location-finder",
                COMP_ERROR: "error",
                COMP_WENT_WRONG: "wentwrong",
                ADD_LOCATION: "location-add",
                SELECT_LOCATION: "location-select",
                SELECT_CURRENT_LOCATION: "current-location-select",
                REMOVE_LOCATION: "location-remove",
                SELECT_LOC_PERMISSION: "location-permission-select",
                SIDEBAR_OPEN: "sidebar-open",
                SIDEBAR_CLOSE: "sidebar-close",
                TOGGLE_NEWS: "toggle-news",
                TOGGLE_WEATHER_FORECAST: "toggle-weather-forecast",
                NEWS_CLICK: "news_clicked",
                WINDYS_VIEW_LARGER_MAP: "view_larger_map",
                DFP_ADS_IMPRESSION: "ma_Display_Ad_Impression",
                REMOVE_ADS: "remove-ads",
                SHOW_MORE: "show-more",
                ADDITIONAL_FORECAST: "additional-forecast",
                SHARE: "share"
            },
            LABEL: {
                TIME_DAILY: "daily",
                TIME_HOURLY: "hourly",
                NEWS_WEATHER: "weather",
                NEWS_ALL: "ALL",
                FIVE_DAYS: "five_days",
                EIGHT_DAYS: "eight-days",
                AD_SLOT_MIDDLE: "ad_slot_pos_middle",
                WEATHER_PAGE: "-1screen",
                SIDEBAR: "sidebar",
            }
        },
        PAGE_VIEW: {
            WEATHER_PAGE: "/comp/weather",
            LOADING_PAGE: "/comp/loading",
            ERROR_PAGE: "/comp/error",
            LOCATION_FINDER_PAGE: "/comp/location-finder",
        },
        USER_ID: "user_id",
    },
}



// WEBPACK FOOTER //
// ./src/common/constants.js